var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex align-items-center department-item one"},[_c('div',{staticClass:"content-item-label"},[_vm._v("建议科室")]),_c('el-cascader',{ref:"cascader",attrs:{"placeholder":"请选择科室","value":_vm.select,"options":_vm.departmentList,"props":_vm.departmentProps,"show-all-levels":false},on:{"change":_vm.changeDepartment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }